// Sanity check de carga en C4: compara el total de paquetes de la versión
// nueva contra la versión VIGENTE de la misma (cliente, planta) y devuelve un
// aviso si la diferencia es drástica (caída ≥90% o aumento ≥10×). No bloquea:
// el coordinador puede confirmar y cargar igual. Motivado por el caso
// Entrerríos 2026-W24: se cargó la columna equivocada del Excel (2.878 paq
// reemplazando un plan de 758.432) y nada avisó.

import type { ProgramacionResumen } from 'schemas';

/** Versión vigente comparable: mismo cliente y misma planta (o tenant-wide). */
export function vigenteComparable(
  programaciones: ProgramacionResumen[],
  clienteId: string,
  plantaId: string | null,
): ProgramacionResumen | null {
  return (
    programaciones.find(
      (p) =>
        p.cliente_id === clienteId &&
        p.vigente_hasta === null &&
        (p.planta_id === null || plantaId === null || p.planta_id === plantaId),
    ) ?? null
  );
}

export function avisoTotalSospechoso(totalNuevo: number, totalVigente: number): string | null {
  if (totalVigente <= 0 || totalNuevo <= 0) return null;
  const fmt = (n: number) => Math.round(n).toLocaleString('es-CO');
  const ratio = totalNuevo / totalVigente;
  if (ratio <= 0.1) {
    return `El total de esta carga (${fmt(totalNuevo)} paq) es un ${Math.round(
      (1 - ratio) * 100,
    )}% MENOR que la versión vigente (${fmt(
      totalVigente,
    )} paq). Verifique que la columna de cantidades sea la correcta antes de reemplazar el programa.`;
  }
  if (ratio >= 10) {
    return `El total de esta carga (${fmt(totalNuevo)} paq) es ${Math.round(
      ratio,
    )} veces la versión vigente (${fmt(
      totalVigente,
    )} paq). Verifique las cantidades antes de reemplazar el programa.`;
  }
  return null;
}
